import React from 'react';
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../shared/ui/modal/ModalCustom";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {UseFormSubmitModel} from "../../../shared/utils/forms/models/UseFormModel";
import {useForm} from "../../../shared/utils/forms/useForm";

const ModalSaveModel = ({confirmHandler, closeHandler}: any) => {
    const structureData: any[] = [
        {
            type: 'input',
            name: "nameModel",
            label: "Nome modello",
            dataElement: {
                placeholder: "Inserisci nome modello",
                type: 'text',
            },
            col: {xs: "12"},
        },
    ]
    const validationData = {
        nameModel: {
            required: {
                params: {
                    name: "Nome modello",
                },
            },
        },
    }

    const submitHandler: UseFormSubmitModel = (event, data) => {
        confirmHandler(data)
    };
    const {
        isSubmit,
        errors,
        submitAction,
        changeValue,
        dataForm,
        setData
    } = useForm(submitHandler, validationData);

    return (
        <ModalCustom title={"Salvataggio del modello"} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={submitAction}>Conferma</BtnPrimary>
                     </div>}>
            <p>Inserisci il nome del modello da salvare.</p>
            <FormElements
                structure={structureData}
                dataForm={dataForm}
                errors={errors}
                isSubmit={isSubmit}
                changeValue={changeValue}
            />
        </ModalCustom>
    );
};

export default ModalSaveModel;
